import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-black text-white font-sans" data-id="element-67">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-24" data-id="element-68">
        <Link to="/" className="inline-flex items-center gap-2 text-sm tracking-wide text-white/70 hover:text-brand-gold transition-colors duration-300 mb-12" data-id="element-69">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-70" />
          Back to pollockventures.com
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-2" data-id="element-71">
          Privacy Policy
        </h1>
        <p className="text-sm text-white/50 mb-12" data-id="element-72">
          Effective Date: May 2, 2026
        </p>

        <div className="space-y-8 text-white/80 leading-relaxed text-base" data-id="element-73">
          <p data-id="element-74">
            Pollock Venture Partners, LLC ("Company," "we," "us," or "our")
            operates the website www.pollockventures.com (the "Site"). This
            Privacy Policy explains how we collect, use, and protect your
            information.
          </p>

          <Section title="1. Information We Collect" data-id="element-75">
            <p data-id="element-76">We may collect the following types of information:</p>
            <h3 className="text-white font-medium mt-4 mb-2" data-id="element-77">
              a. Information You Provide
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-78">
              <li data-id="element-79">
                Name, email address, or other details you submit via contact
                forms or email
              </li>
            </ul>
            <h3 className="text-white font-medium mt-4 mb-2" data-id="element-80">
              b. Automatically Collected Information
            </h3>
            <ul className="list-disc pl-6 space-y-1" data-id="element-81">
              <li data-id="element-82">IP address</li>
              <li data-id="element-83">Browser type and device information</li>
              <li data-id="element-84">Pages visited and time spent on the Site</li>
              <li data-id="element-85">Cookies and similar tracking technologies</li>
            </ul>
          </Section>

          <Section title="2. How We Use Your Information" data-id="element-86">
            <p data-id="element-87">We use information to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-88">
              <li data-id="element-89">Operate and maintain the Site</li>
              <li data-id="element-90">Respond to inquiries or communications</li>
              <li data-id="element-91">Improve site performance and user experience</li>
              <li data-id="element-92">Monitor usage and analytics</li>
            </ul>
          </Section>

          <Section title="3. Cookies and Tracking" data-id="element-93">
            <p data-id="element-94">We may use cookies or similar technologies to:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-95">
              <li data-id="element-96">Understand user behavior</li>
              <li data-id="element-97">Improve functionality</li>
              <li data-id="element-98">Analyze traffic (e.g., via analytics tools)</li>
            </ul>
            <p className="mt-3" data-id="element-99">
              You can control cookies through your browser settings.
            </p>
          </Section>

          <Section title="4. Sharing of Information" data-id="element-100">
            <p data-id="element-101">We do not sell your personal information.</p>
            <p className="mt-3" data-id="element-102">We may share information with:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-103">
              <li data-id="element-104">Service providers (e.g., analytics tools)</li>
              <li data-id="element-105">Legal authorities if required by law</li>
            </ul>
          </Section>

          <Section title="5. Your Rights" data-id="element-106">
            <p data-id="element-107">
              Depending on your location (including California), you may have
              rights to:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-108">
              <li data-id="element-109">Request access to your data</li>
              <li data-id="element-110">Request deletion of your data</li>
              <li data-id="element-111">Opt out of certain data uses</li>
            </ul>
            <p className="mt-3" data-id="element-112">
              To exercise these rights, contact us at:{' '}
              <a href="mailto:legal@pollockventures.com" className="text-brand-gold hover:underline" data-id="element-113">
                legal@pollockventures.com
              </a>
            </p>
          </Section>

          <Section title="6. Data Security" data-id="element-114">
            <p data-id="element-115">
              We take reasonable measures to protect your information, but no
              system is completely secure.
            </p>
          </Section>

          <Section title="7. Third-Party Links" data-id="element-116">
            <p data-id="element-117">
              The Site may contain links to third-party websites. We are not
              responsible for their privacy practices.
            </p>
          </Section>

          <Section title="8. Changes to This Policy" data-id="element-118">
            <p data-id="element-119">
              We may update this Privacy Policy from time to time. Updates will
              be posted on this page with a revised effective date.
            </p>
          </Section>

          <Section title="9. Contact Information" data-id="element-120">
            <p data-id="element-121">Pollock Venture Partners, LLC</p>
            <p data-id="element-122">16192 Coastal Highway</p>
            <p data-id="element-123">Lewes, DE 19958</p>
            <p className="mt-3" data-id="element-124">
              Email:{' '}
              <a href="mailto:legal@pollockventures.com" className="text-brand-gold hover:underline" data-id="element-125">
                legal@pollockventures.com
              </a>
            </p>
          </Section>
        </div>
      </div>
    </main>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-126">
      <h2 className="font-heading text-xl sm:text-2xl font-light tracking-tight text-white mb-3" data-id="element-127">
        {title}
      </h2>
      <div className="space-y-2" data-id="element-128">{children}</div>
    </section>;
}